<template>
  <div class="tab-container">
    <div class="title" v-if="titleFlag">全部出价</div>
    <Table :tableData="dataTable" :option="option"></Table>
  </div>
</template>
<script>
import Table from "./Table.vue";
export default {
  components: {
    Table,
  },
  props: {
    titleFlag: Boolean,
    dataTable: Array,
  },
  data() {
    return {
      option: {
        column: [
          { title: "闪购客户", key: "buyerName" },
          { title: "闪购时间", key: "createTime" },
          { title: "闪购量（吨）", key: "weight" },
        ],
      },
    };
  },
};
</script>
<style lang="stylus" scoped>
.tab-container {
  .title {
    height: 88px;
    font-size: 30px;
    padding-left: 25px;
    line-height: 88px;
    font-weight: bold;
  }
}
</style>